import React from 'react';
import { motion } from "framer-motion";
import useMediaQuery from '../hooks/useMediaQuery';
import LineGradient from '../components/LineGradient';
import InternProjects from './InternProjects';

const InternWorks = () => {

    const isAboveLarge = useMediaQuery("(min-width: 1060px)");

    return (
        <section id="experience" className=" pb-12">
            {/* HEADER AND IMAGE SECTION */}
            <div className="mt-12">
                <motion.div
                    // className="md:w-1/3"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.5 }}
                    variants={{
                        hidden: { opacity: 0, x: -50 },
                        visible: { opacity: 1, x: 0 },
                    }}
                >
                    <p className="font-playfair font-semibold text-4xl mb-5">
                        <span className="text-cyan-500">SOME OFFICE WORKS</span>
                    </p>
                    <LineGradient width=" w-[100px]" />
                    <p className="mt-8 text-justify">
                        I have actively engaged in multiple projects throughout my internship and professional journey, where I have applied and refined skills that align with my career growth. These experiences have enabled me to acquire a diverse skill set and deepen my expertise across various technologies and methodologies.

                        Below, I have provided links to videos and live sites for several projects, each accompanied by a detailed description of my contributions and the skills I applied. Please explore the following projects to gain insight into my professional work and technical abilities.
                    </p>

                </motion.div>

            </div >
            <div>
                <InternProjects></InternProjects>
            </div>

        </section >
    );
};

export default InternWorks;